// extracted by mini-css-extract-plugin
module.exports = {"root":"commission_rule_root__1buVj","alarm":"commission_rule_alarm__2kY74"};